/** Raw `audit_table.name` values — resolve to id via AuditTable dictionary. */
export const AuditTable = {
    BetOrder: 'bet_order',
    Bot: 'bot',
    CurrencyExchange: 'currency_exchange',
    Proxy: 'proxy',
    Site: 'site',
    SiteAccount: 'site_account',
    ToolUser: 'tool_user',
    ToolUserDocument: 'tool_user_document',
    Transfer: 'transfer',
    WlTransaction: 'wl_transaction',
    League: 'league',
    CustomLeague: 'custom_league',
    Team: 'team',
    CustomTeam: 'custom_team',
} as const;

export type AuditTableName = (typeof AuditTable)[keyof typeof AuditTable];
